import React, { Component } from 'react';
import Bible from './bible/Bible';
//import BookVerses from './js/BookVerses';
//import BookView from './books/BookView';
import { connect } from 'react-redux';
import Header2 from './Header2';
import Immutable from './util/Immutable';
import LexiconView from './lexicon/LexiconView';
import PropTypes from 'prop-types';
import SearchView from './search/SearchView';
import SelectedVersions, { SelectAction } from './versions/SelectedVersions';
import { Set } from 'immutable';
import Settings from './Settings';
import * as SettingsState from './redux/SettingsState';
import SideSearchView from './search3/SideSearchView';
import SplitterLayout from 'react-splitter-layout';
import TabContent from './tabs/TabContent';
import TabView from './tabs/TabView';
import VerseHistory from './verses/VerseHistory';
//import VerseVersions from './models/VerseVersions';
import VerseView from './verses/VerseView';
import VersionStore from './new/versions/VersionStore';
import VersionView from './versions/VersionView';
import './MainView.css';

const mapDispatchToProps = (dispatch) => ({
    setVisibleVersions: (versionIndexes) => dispatch(SettingsState.setVisibleVersions(versionIndexes))
});

class MainView extends Component {
    static contextTypes = {
        bible: PropTypes.instanceOf(Bible).isRequired,
        //verses: PropTypes.instanceOf(Map).isRequired,
        //versions: PropTypes.instanceOf(Map).isRequired,
        versions: PropTypes.instanceOf(VersionStore).isRequired
    }

    static tabs = [
        { id: 'search', title: 'Search Results', icon: 'search' },
        { id: 'lexicon', title: 'Lexicon', icon: 'book' },
        { id: 'versions', title: 'Versions', icon: 'translate', align: 'right' }
    ];

    constructor(props, context) {
        super(props);
        this.settings = new Settings();
        const initialVerse = context.bible.getVerse(0);
        this.state = {
            initialFocusedVerse: Immutable.of(initialVerse),
            currentFocusedVerse: Immutable.of(initialVerse),
            verseHistory: Immutable.of(new VerseHistory(initialVerse)),
            highlightQuery: null,
            //showBooks: true,
            //showVersions: this.settings.getVersionsPaneVisible(),
            selectedVersions: this.createSelectedVersions(context.versions),
            //bookVerses: BookVerses.empty(),
            verseIndex: null,
            //openTabId: null,
            openTabIds: new Set(this.settings.getOpenTabs()),
            lexiconProps: null,
            searchProps: null,
            //verseVersions: [],
            //tabs: []
        };

        const selectedVersions = this.settings.getSelectedVersions();
        if (Array.isArray(selectedVersions) && selectedVersions.length > 0) {
            this.state.selectedVersions = this.state.selectedVersions.setAll(false).setMany(selectedVersions, SelectAction.SELECT, false);
        }
        props.setVisibleVersions(this.state.selectedVersions.getSelected());

        //this.lastSelectedVerseIndex = -1;
        //this.onSearchHighlightChange = this.onSearchHighlightChange.bind(this);
        this.onVerseSelect = this.onVerseSelect.bind(this);
        this.onSearchFullSearch = this.onSearchFullSearch.bind(this);
        //this.onToggleBooks = this.onToggleBooks.bind(this);
        //this.onToggleVersions = this.onToggleVersions.bind(this);
        this.focusVerse = this.focusVerse.bind(this);
        this.onBookChange = this.onBookChange.bind(this);
        this.onChapterChange = this.onChapterChange.bind(this);
        this.onVerseChange = this.onVerseChange.bind(this);
        this.onWordClick = this.onWordClick.bind(this);
        this.onSelectedVersionsChange = this.onSelectedVersionsChange.bind(this);
        this.onTabClick = this.onTabClick.bind(this);
        this.onSearchPaneSizeChange = this.onSearchPaneSizeChange.bind(this);
        this.onVersionsPaneSizeChange = this.onVersionsPaneSizeChange.bind(this);
        this.onTabPaneSizeChange = this.onTabPaneSizeChange.bind(this);
        this.onTabPaneSplitChange = this.onTabPaneSplitChange.bind(this);
        this.openTab = this.openTab.bind(this);
        this.toggleTab = this.toggleTab.bind(this);
        this.isTabOpen = this.isTabOpen.bind(this);
    }

    createSelectedVersions(versions) {
        return SelectedVersions.create(versions.getAllVersions(), true)
            .withTrigger(versions.getVersionByCode('WLCi').getIndex(), [versions.getVersionByCode('KJVi').getIndex()])
            .withTrigger(versions.getVersionByCode('WHOi').getIndex(), [versions.getVersionByCode('KIT').getIndex()]);
    }

    /*onSearchHighlightChange(text) {
        this.setState({ highlightText: text });
    }*/

    onVerseSelect(verseIndex) {
        //this.setState({ verseIndex });

        if (this.verseView) {
            this.verseView.scrollToIndex(verseIndex);
        }

        /*if (this.state.bookVerses.containsVerse(verseIndex)) {
            this.verseView.scrollToIndex(this.state.bookVerses.getArrayPositionForVerse(verseIndex));
            return;
        }

        VerseVersions.getBookForVerse(verseIndex)
                .then(bookVerses => {
                    const verses = new BookVerses(bookVerses);
                    this.setState({ bookVerses: verses }, () =>
                        this.verseView.scrollToIndex(verses.getArrayPositionForVerse(verseIndex)));
                })
                .catch(error => console.log(error));*/

        /*if (verseIndex !== this.lastSelectedVerseIndex) {
            this.lastSelectedVerseIndex = verseIndex;
            VerseVersions.getBookForVerse(verseIndex)
                    .then(verseVersions => { console.log(verseVersions); this.setState({ verseVersions }); })
                    .catch(error => console.log(error));
        }*/
    }

    onSearchFullSearch(query) {
        this.setState({
            searchProps: {
                query
            },
            //openTabId: 'search',
            highlightQuery: query
        });
        this.openTab('search');
    }

    /*onToggleBooks() {
        this.setState(prevState => ({ showBooks: !prevState.showBooks }));
    }*/

    //onToggleVersions(showVersions) {
        /*this.setState(prevState => {
            const showVersions = !prevState.showVersions;
            this.settings.setVersionsPaneVisible(showVersions);
            return { showVersions };
        });*/
        //this.settings.setVersionsPaneVisible(showVersions);
        //this.setState({ showVersions });
    //}

    focusVerse(verse) {
        this.setState({
            initialFocusedVerse: Immutable.of(verse),
            currentFocusedVerse: Immutable.of(verse),
            verseHistory: this.state.verseHistory.mutate(value => value.addVerse(verse))
        });
    }

    onBookChange(bookIndex) {
        this.focusVerse(this.context.bible.getBook(bookIndex).getChapter(1).getVerse(1));
    }

    onChapterChange(chapterIndex) {
        this.focusVerse(this.context.bible.getChapter(chapterIndex).getVerse(1));
    }

    onVerseChange(verseIndex) {
        this.focusVerse(this.context.bible.getVerse(verseIndex));
    }

    onWordClick(verseIndex, sourceIndex, wordIndex, partIndex, text) {
    //onWordClick(verseVersionIndex, /*verseIndex, versionIndex,*/ wordIndex, word) {
        this.setState({
            lexiconProps: {
                verseIndex,
                sourceIndex,
                wordIndex,
                partIndex
            },
            //openTabId: 'lexicon'
        });
        this.openTab('lexicon');
        //alert(word);
        //const tabs = this.state.tabs;
        //tabs.push({ title: word, content: <LexiconTab word={word} /> });
        //this.setState({ tabs: tabs });
    }

    onSelectedVersionsChange(selectedVersions) {
        this.props.setVisibleVersions(selectedVersions.getSelected());
        this.settings.setSelectedVersions(selectedVersions.getSelected());
        this.setState({ selectedVersions });
    }

    onTabClick(tabId) {
        this.toggleTab(tabId);
    }

    onSearchPaneSizeChange(size) {
        this.settings.setSearchPaneSize(size);
    }

    onVersionsPaneSizeChange(size) {
        this.settings.setVersionsPaneSize(size);
    }

    onTabPaneSizeChange(size) {
        this.settings.setTabPaneSize(size);
    }

    onTabPaneSplitChange(size) {
        this.settings.setTabSplitPosition(size);
    }

    openTab(tabId) {
        this.setState((prevState) => {
            const openTabIds = prevState.openTabIds.add(tabId);
            this.settings.setOpenTabs(openTabIds.toArray());
            return { openTabIds };
        });
    }

    toggleTab(tabId) {
        this.setState((prevState) => {
            const openTabIds = prevState.openTabIds.has(tabId) ?
                prevState.openTabIds.delete(tabId) :
                prevState.openTabIds.add(tabId);
            this.settings.setOpenTabs(openTabIds.toArray());
            return { openTabIds };
        });
    }

    isTabOpen(tabId) {
        return this.state.openTabIds.has(tabId);
    }

    renderTabContent(tabId) {
        var content;
        switch (tabId) {
            case 'lexicon':
                content = <LexiconView {...this.state.lexiconProps} />;
                break;
            case 'search':
                content = <SearchView {...this.state.searchProps} onVerseClick={this.onVerseSelect} />;
                break;
            default:
                content = null;
        }
        if (content !== null) {
            return <TabContent>{content}</TabContent>;
        } else {
            return null;
        }
    }

    render() {
        return (
            <div className="MainView">
                {/*<Header
                    versionsVisible={this.isTabOpen('versions')}
                    //onSearchHighlightChange={this.onSearchHighlightChange}
                    onSearchVerseSelect={this.onVerseSelect}
                    onSearchFullSearch={this.onSearchFullSearch}
                    //onToggleBooks={this.onToggleBooks}
                    //onToggleVersions={this.onToggleVersions}
                    />*/}
                <Header2
                    focusedVerse={this.state.currentFocusedVerse.get()}
                    bible={this.context.bible}
                    showVerse={this.state.selectedVersions.selectedCount() !== 1}
                    verseHistory={this.state.verseHistory}
                    onVerseSearch={this.onSearchFullSearch}
                    onBookChange={this.onBookChange}
                    onChapterChange={this.onChapterChange}
                    onVerseChange={this.onVerseChange} />
                <div className="MainView_Content">
                    <SplitterLayout
                        vertical={true}
                        percentage={true}
                        secondaryInitialSize={this.settings.getTabPaneSize()}
                        secondaryMinSize={5}
                        onSecondaryPaneSizeChange={this.onTabPaneSizeChange}>
                        <SplitterLayout
                            primaryIndex={1}
                            secondaryInitialSize={this.settings.getSearchPaneSize()}
                            secondaryMinSize={Settings.minSearchPaneSize}
                            onSecondaryPaneSizeChange={this.onSearchPaneSizeChange}>
                            {this.isTabOpen('search') && <SideSearchView
                                {...this.state.searchProps}
                                onVerseClick={this.onVerseSelect} />}
                            <SplitterLayout
                                secondaryInitialSize={this.settings.getVersionsPaneSize()}
                                secondaryMinSize={Settings.minVersionsPaneSize}
                                onSecondaryPaneSizeChange={this.onVersionsPaneSizeChange}>
                                <VerseView
                                    //verseIndex={this.state.verseIndex}
                                    initialFocusedVerse={this.state.initialFocusedVerse}
                                    currentFocusedVerse={this.state.currentFocusedVerse}
                                    verseHistory={this.state.verseHistory}
                                    selectedVersions={this.state.selectedVersions}
                                    highlightQuery={this.state.highlightQuery}
                                    focusVerse={this.focusVerse}
                                    onWordClick={this.onWordClick}
                                    onBookChange={this.onBookChange}
                                    onChapterChange={this.onChapterChange}
                                    onVerseChange={this.onVerseChange}
                                    ref={element => this.verseView = element} />
                                {this.isTabOpen('versions') && <VersionView
                                    versions={this.context.versions}
                                    selectedVersions={this.state.selectedVersions}
                                    onSelectedVersionsChange={this.onSelectedVersionsChange} />}
                                {/*this.state.showVersions && <VersionView
                                    versions={this.context.versions2} />*/}
                            </SplitterLayout>
                        </SplitterLayout>
                        {/*this.renderTabContent(this.state.openTabId)*/}
                        {/*(this.isTabOpen('lexicon') || this.isTabOpen('search')) && <SplitterLayout
                            percentage={true}
                            secondaryInitialSize={this.settings.getTabSplitPosition()}
                            onSecondaryPaneSizeChange={this.onTabPaneSplitChange}>*/}
                            {this.isTabOpen('lexicon') && this.renderTabContent('lexicon')}
                            {/*this.isTabOpen('search') && this.renderTabContent('search')*/}
                        {/*</SplitterLayout>*/}
                    </SplitterLayout>
                </div>
                <TabView
                    tabs={MainView.tabs}
                    openTabIds={this.state.openTabIds.toArray()}
                    onTabClick={this.onTabClick} />
            </div>
        );
    }
}

export default connect(null, mapDispatchToProps)(MainView);
